import { makeSelectors } from '@/store/repository';
import { ApiAssetFilter } from 'kes-common';

const selector = makeSelectors<ApiAssetFilter>();

export const { get } = selector; // eslint-disable-line import/prefer-default-export
